import { IAngularEvent, IRootScopeService } from "angular";
import { SurveyService } from "./survey";
import { IAppConfig } from "@gtmhub/env";
import { GoalsChangedEventArgs } from "../okrs";
import { TransitionService } from "@uirouter/angularjs";

const mod = angular.module("delighted", []);

mod.service("SurveyService", SurveyService);
mod.run([
  "$rootScope",
  "$transitions",
  "appConfig",
  "SurveyService",
  ($rootScope: IRootScopeService, $transitions: TransitionService, appConfig: IAppConfig, surveyService: SurveyService) => {
    $rootScope.$on("authorizationProcessed", () => {
      if (appConfig.delighted.enabled) {
        surveyService.execDelightedSurvey();
      }
    });

    $rootScope.$on("accountDataInitialized", () => {
      if (appConfig.delightedNewNavi.enabled) {
        surveyService.execDelightedNewNaviSurvey();
      }
    });

    const cesEventHandler = (e: IAngularEvent) => {
      if (appConfig.delightedCES.enabled) {
        surveyService.execDelightedCESSurvey(e.name);
      }
    };

    $rootScope.$on("okrs.goalsChanged", (event: IAngularEvent, args: GoalsChangedEventArgs) => {
      switch (args.reason) {
        case "goalCreated":
        case "metricCreated":
          cesEventHandler(event);
          break;
      }
    });
    // We've gathered enough responses, the CES score is high and no further actions are required for now. The CES on this event needs to be paused.
    // $rootScope.$on("metricSnapshotCreated", cesEventHandler);

    let listSurveyTrigger: () => void;
    $rootScope.$on("listCreated", () => {
      if (appConfig.delightedCES.enabled && !listSurveyTrigger) {
        listSurveyTrigger = $rootScope.$on("listFiltersUpdated", () => {
          surveyService.execDelightedCESSurvey("listCreated");

          listSurveyTrigger();
          listSurveyTrigger = null;
        });
      }
    });

    let unsubscribeSuccessTransition: () => void;
    $rootScope.$on("taskCreated", () => {
      if (appConfig.delightedCES.enabled && !unsubscribeSuccessTransition) {
        unsubscribeSuccessTransition = $transitions.onSuccess({}, () => {
          surveyService.execDelightedCESSurvey("taskCreated");

          unsubscribeSuccessTransition();
          unsubscribeSuccessTransition = null;
        });
      }
    });
  },
]);

export default mod.name;
